<nav
    class="navbar navbar-expand-lg navbar-light bg-white py-0"
    [hidden]="!showMenu"
>
    <div
        class="d-flex justify-content-between flex-lg-row flex-column w-100 nav-padding my-lg-0 my-3"
    >
        <div
            class="d-flex justify-content-between align-content-center align-items-center"
        >
            <div class="d-flex">
                <a
                    class="navbar-brand p-0 me-0 me-3"
                    [routerLink]="urlPrefix + '/home'"
                    (click)="navbarCollapsed = true"
                >
                    <img
                        id="menuLogoTexas"
                        [attr.src]="'menu-logo-texas' | cmsImageSrc | async"
                        [attr.alt]="'menu-logo-texas' | cmsImageAlt | async"
                        height="50"
                    />
                </a>
                <a
                    *ngIf="
                        citySelected && contentService.valueExists('menu-logo')
                            | async
                    "
                    class="navbar-brand p-0"
                    [routerLink]="urlPrefix + '/home'"
                    (click)="navbarCollapsed = true"
                >
                    <img
                        id="menuLogo"
                        [attr.src]="'menu-logo' | cmsImageSrc | async"
                        [attr.alt]="'menu-logo' | cmsImageAlt | async"
                        height="50"
                    />
                </a>
            </div>
            <div>
                <button
                    class="navbar-toggler order-lg-1"
                    [hidden]="!showMenuLinks"
                    type="button"
                    (click)="navbarCollapsed = !navbarCollapsed"
                    [attr.aria-expanded]="!navbarCollapsed"
                    aria-controls="navbarContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <div class="bar bar1"></div>
                    <div class="bar bar2"></div>
                    <div class="bar bar3"></div>
                </button>
            </div>
        </div>
        <div class="d-flex justify-content-end align-items-stretch">
            <div
                class="collapse navbar-collapse mt-1 mt-lg-0"
                [ngbCollapse]="navbarCollapsed"
                id="navbarContent"
            >
                <div
                    [hidden]="!showMenuLinks"
                    *ngIf="communityIsValid | async"
                    class="navbar-nav"
                >
                    <ng-container *ngFor="let item of items">
                        <a
                            *ngIf="!item.children"
                            class="d-flex nav-link ms-lg-2 ms-xl-4 ps-3 ps-lg-0 py-lg-4 text-center"
                            [routerLink]="item.url"
                            id="{{ item.id }}"
                            routerLinkActive="active"
                            (click)="navbarCollapsed = true"
                        >
                            <span class="align-self-center">
                                {{ item.cmsKey | cmsText | async }}
                            </span>
                        </a>
                        <div
                            *ngIf="item.children"
                            routerLinkActive="active"
                            ngbDropdown
                            display="dynamic"
                            placement="bottom-end"
                            class="d-inline-block d-lg-flex"
                        >
                            <button
                                class="nav-link d-flex align-items-center w-100 justify-content-between text-wrap ms-lg-2 ms-xl-4 py-lg-4"
                                [id]="item.id + '-dropdown'"
                                ngbDropdownToggle
                            >
                                <span class="ps-3 ps-lg-0">{{
                                    item.cmsKey | cmsText | async
                                }}</span>
                                <i
                                    class="fa fa-sm fa-chevron-down ms-2 me-4 me-lg-0"
                                ></i>
                            </button>
                            <div
                                ngbDropdownMenu
                                [attr.aria-labelledby]="item.id + '-dropdown'"
                                [attr.name]="item.id + '-dropdown'"
                            >
                                <ng-container
                                    *ngFor="let childItem of item.children"
                                >
                                    <a
                                        *ngIf="childItem.isExternalLink"
                                        class="dropdown-item"
                                        [href]="childItem.url"
                                        target="_blank"
                                        (click)="moreInfoDropdownClick()"
                                    >
                                        {{ childItem.cmsKey | cmsText | async }}
                                    </a>
                                    <a
                                        *ngIf="!childItem.isExternalLink"
                                        class="dropdown-item"
                                        [routerLink]="childItem.url"
                                        routerLinkActive="active"
                                        (click)="moreInfoDropdownClick()"
                                    >
                                        {{ childItem.cmsKey | cmsText | async }}
                                    </a>
                                </ng-container>
                            </div>
                        </div>
                    </ng-container>
                    <a
                        class="nav-link d-flex nav-link ms-lg-2 ms-xl-4 ps-3 ps-lg-0 py-lg-4 text-center language-link"
                        (click)="setLanguage(targetLanguageCode)"
                    >
                        <span class="align-self-center">
                            {{
                                'choose-language-' + targetLanguageCode
                                    | cmsText
                                    | async
                            }}
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</nav>
<div class="fixed-top" style="max-width: 300px">
    <span
        class="badge badge-info ms-4"
        *ngIf="authService.user$ | async; let admin"
        >{{ admin.name }}</span
    >
</div>
